import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { changeCurrentOrder } from '../../Actions/changeCurrentOrder';
// import preloader from '../../images/preloader.gif';

const Counter = props => {
  const { good, orderGoods, changeOrder } = props;

  const changeCount = val => {
    if (+good.count + val < 0) return;
    const changeGoods = orderGoods.map(i => {
      if (i.shopGood === good.shopGood) {
        return { ...i, count: +i.count + val };
      }
      return i;
    });
    if (+good.count + val < 1) {
      changeOrder({ goods: changeGoods }, 0, 1);
    } else {
      changeOrder({ goods: changeGoods });
    }
  };

  const hendleInput = e => {
    let value = Number(e.target.value);
    if (!value || value < 1) value = 0;
    if (value > 999) value = 999;
    const changeGoods = orderGoods.map(i => {
      if (i.shopGood === good.shopGood) {
        return { ...i, count: value };
      }
      return i;
    });
    changeOrder({ goods: changeGoods });
  };

  return (
    <div className="counter-section">
      <div className="counter">
        <div className="left-btn" onClick={() => changeCount(-1)}>-</div>
        <div>
          <input
            className="count"
            name="count"
            value={good.count}
            onChange={hendleInput}
            // onKeyDown={this.pressBtn}
            // onBlur={this.lossFocus}
          />
        </div>
        <div className="right-btn" onClick={() => changeCount(1)}>+</div>
      </div>
    </div>
  );
};

Counter.defaultProps = {
  changeOrder: PropTypes.func
};

const mapStateToProps = state => ({
  orderGoods: state.currentOrder.order && state.currentOrder.order.goods
});

const mapDispatchToProps = {
  changeOrder: changeCurrentOrder
};

export default connect(mapStateToProps, mapDispatchToProps)(Counter);
